// import { Component, OnInit, ViewChild } from "@angular/core";
// import { UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from "@angular/forms";
// import { UserListComponent } from "../user-list/user-list.component";
// import { UserService } from "../user.service";
// import { ToastrService } from 'ngx-toastr';
// import { SimpleModalService } from 'ngx-simple-modal';
// import { ConfirmComponent } from "../../views/confirm/confirm.component";

// @Component({
//   selector: "app-user-add",
//   templateUrl: "./user-add.component.html",
//   styleUrls: ["./user-add.component.scss"],
// })
// export class UserAddComponent implements OnInit {
//   public userId: number;
//   public overallRating: number;
//   isViewOnly: boolean = false;
//   public userdate;
//   isEditable: boolean = false;
//   public userForm: UntypedFormGroup;
//   public imagePath: String;

//   @ViewChild(UserListComponent) child: UserListComponent;
//   constructor(private simpleModalService: SimpleModalService, private toastr: ToastrService, private userService: UserService) {

//     this.userForm = new UntypedFormGroup({
//       first_name: new UntypedFormControl("", [
//         Validators.required,
       
//       ]),
//       last_name: new UntypedFormControl("", [
//         Validators.required,
       
//       ]),
//       phone_number: new UntypedFormControl("", [
//         Validators.required,
       
//       ]),
//       email: new UntypedFormControl("", [
//         Validators.maxLength(30),
//         Validators.pattern(/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i),
//         Validators.required
//       ]),

//       company_name: new UntypedFormControl("", [
        
//       ]),
//       business_address: new UntypedFormControl("", [
       
//       ]),
//       business_type: new UntypedFormControl("", [
        
//       ]),
//       tax_number: new UntypedFormControl("", [
        
//       ]),
//       license_pic: new UntypedFormControl("", [
        
//       ]),
//       vehicleType: new UntypedFormControl("", []),
//       homeCity: new UntypedFormControl("", []),
//       emiratesIdBack: new UntypedFormControl("", []),
//       profile_pic: new UntypedFormControl("", []),
//     });
//   }

//   ngOnInit() {
//     debugger
//     console.log("working");
//     console.log(this.userId);
//     if (this.userId) {
//       this.userService.getUserById(this.userId).subscribe((usr: any) => {
//         console.log('User Details Response:', usr);
//         if (usr.status === '1' && !usr.error) {
//           this.userdate = usr.userDetails;
//           this.userForm.patchValue({
//             first_name: usr.userDetails.first_name || '',
//             last_name: usr.userDetails.last_name || '',
//             phone_number: usr.userDetails.phone_number || '',
//             email: usr.userDetails.email || '',
//             company_name: usr.userDetails.company_name || '',
//             business_address: usr.userDetails.business_address || '',
//             business_type: usr.userDetails.business_type || '',
//             tax_number: usr.userDetails.tax_number || '',
//             vehicleType: usr.userDetails.vehicleType || usr.userDetails.vehicle_type || '',
//             homeCity: usr.userDetails.homeCity || usr.userDetails.city || '',
//             emiratesIdBack: usr.userDetails.emiratesIdBack || usr.userDetails.eid_back_pic || ''
//           });
//           this.imagePath = usr.userDetails.profile_pic;
//           this.isEditable = true;
//         } else {
//           this.toastr.error(usr.message || 'Failed to load user details');
//         }
//       }, (error) => {
//         console.error('Error loading user details:', error);
//         this.toastr.error(error.error?.message || 'Failed to load user details');
//       });

//       this.userService.getUserRatingById(this.userId).subscribe((usr: any) => {
//         this.overallRating = parseFloat(usr.customerData[0].overallRating.$numberDecimal);
//       });
//     }
//   }

//   submitted = false;
//   onSubmitUser() {
//     this.submitted = true;
//     console.log('this.userForm.valid', this.userForm.valid)
//     if (this.userForm.valid) {
//       if (this.isEditable === false) {
//         this.userService.createUser(this.userForm.value).subscribe(() => {
//           this.toastr.success('User has been created.');
//         }, err => {
//           this.toastr.error(err.error.message);
//         });
//       } else {
//         console.log("Updating user...");
//         let userData = this.userForm.value;
        
     
//         const updateData: any = {
//           first_name: userData.first_name,
//           last_name: userData.last_name,
//           phone_number: userData.phone_number,
//           email: userData.email,
//           company_name: userData.company_name || '',
//           business_address: userData.business_address || '',
//           business_type: userData.business_type || '',
//           tax_number: userData.tax_number || '',
//           vehicleType: userData.vehicleType || '',
//           homeCity: userData.homeCity || '',
//           emiratesIdBack: userData.emiratesIdBack || ''
//         };

       
//         if ((userData.profile_pic && typeof userData.profile_pic !== 'string') || 
//             (userData.license_pic && typeof userData.license_pic !== 'string')) {
//           var formData: any = new FormData();
//           Object.keys(updateData).forEach(key => {
//             if (updateData[key] !== null && updateData[key] !== undefined && updateData[key] !== '') {
//               formData.append(key, updateData[key]);
//             }
//           });
//           if (userData.profile_pic && typeof userData.profile_pic !== 'string') {
//             formData.append("profile_pic", userData.profile_pic);
//           }
//           if (userData.license_pic && typeof userData.license_pic !== 'string') {
//             formData.append("license_pic", userData.license_pic);
//           }
          
//           this.userService
//             .putUser(this.userId, formData)
//             .subscribe((response: any) => {
//               if (response.status === '1' && !response.error) {
//                 this.userService.closeOverlay();
//                 this.userService.onCompleted();
//                 this.toastr.success('User has been updated.');
//               } else {
//                 this.toastr.error(response.message || 'Failed to update user');
//               }
//             }, err => {
//               console.error('Update error:', err);
//               this.toastr.error(err.error?.message || 'Failed to update user');
//             });
//         } else {
          
//           this.userService
//             .putUser(this.userId, updateData)
//             .subscribe((response: any) => {
//               if (response.status === '1' && !response.error) {
//                 this.userService.closeOverlay();
//                 this.userService.onCompleted();
//                 this.toastr.success('User has been updated.');
//               } else {
//                 this.toastr.error(response.message || 'Failed to update user');
//               }
//             }, err => {
//               console.error('Update error:', err);
//               this.toastr.error(err.error?.message || 'Failed to update user');
//             });
//         }
//       }

//       this.submitted = false;

//     } else {
//       Object.keys(this.userForm.controls).forEach(key => {

//         const controlErrors: ValidationErrors = this.userForm.get(key).errors;
//         if (controlErrors != null) {
//           Object.keys(controlErrors).forEach(keyError => {
//             console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
//           });
//         }
//       });
//     }
//   }

//   uploadFile(event) {
//     const file = (event.target as HTMLInputElement).files[0];
//     console.log("🚀 ~ file: user-add.component.ts ~ line 138 ~ UserAddComponent ~ uploadFile ~ file", file)
//     this.userForm.patchValue({
//       license_pic: file
//     });
    
//   }

//   uploadProfilePic(event) {
//     const file = (event.target as HTMLInputElement).files[0];
//     console.log("Profile picture file:", file);
//     if (file) {
      
//       const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
//       if (!allowedExtensions.exec(file.name)) {
//         this.toastr.error('Invalid image file type. Please upload JPG, JPEG, PNG or GIF.');
//         return;
//       }
      
      
//       if (file.size > 5 * 1024 * 1024) {
//         this.toastr.error('Image size should be less than 5MB.');
//         return;
//       }

//       this.userForm.patchValue({
//         profile_pic: file
//       });

      
//       const reader = new FileReader();
//       reader.onload = (e: any) => {
//         this.imagePath = e.target.result;
//       };
//       reader.readAsDataURL(file);
//     }
//   }

//   changeuserStatus(status) {
//     this.userService.updateUserApprovStatus(this.userId, status).subscribe(() => {

//       this.userService.closeOverlay();
//       this.userService.onCompleted();
//       this.toastr.success('User status has been updated.');

//     }, err => {
//       this.toastr.error(err.error.message);
//     });

    
//   }

//   clearValue() {
//     this.userForm.reset();
//   }

//   public closeForm() {
//     this.userService.closeOverlay();
//   }

//   onClickDownload(e, columnName) {
//     if (this.userdate[columnName].match(/\.(jpeg|jpg|gif|png)$/) != null) {
//       console.log(this.userdate[columnName])
//       console.log(columnName)
//       e.preventDefault();
//       var link = document.createElement('a');
//       link.href = this.userdate[columnName];
    
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } else {
//       this.toastr.error('Image Not Found');
//     }
//     return false;
//   }

// }
import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators, ValidationErrors } from "@angular/forms";
import { UserListComponent } from "../user-list/user-list.component";
import { UserService } from "../user.service";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: "app-user-add",
  templateUrl: "./user-add.component.html",
  styleUrls: ["./user-add.component.scss"],
})
export class UserAddComponent implements OnInit {

  public userId: number;
  public userdate: any;
  public imagePath: string = "";
  public overallRating: number = 0;
 public licensePreview: string = "";
  isEditable: boolean = false;
  isViewOnly: boolean = false;

  @ViewChild(UserListComponent) child: UserListComponent;

  public userForm: UntypedFormGroup;

  constructor(
    private toastr: ToastrService,
    private userService: UserService
  ) {

    // ------- FORM INITIALIZATION -------
    this.userForm = new UntypedFormGroup({
      first_name: new UntypedFormControl("", [Validators.required]),
      last_name: new UntypedFormControl("", [Validators.required]),
      phone_number: new UntypedFormControl("", [Validators.required]),
      email: new UntypedFormControl("", [
        Validators.required,
        Validators.maxLength(40),
        Validators.pattern(/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)*$/i),
      ]),

      // Business / Individual dependent fields
      company_name: new UntypedFormControl(""),
      business_address: new UntypedFormControl(""),
      business_type: new UntypedFormControl(""),
      tax_number: new UntypedFormControl(""),

      license_pic: new UntypedFormControl(""),
      profile_pic: new UntypedFormControl(""),

      // Rider specific
      vehicleType: new UntypedFormControl(""),
      homeCity: new UntypedFormControl(""),
      emiratesIdBack: new UntypedFormControl(""),
    });
  }

  // -------------------------------------------------------------------
  // ---------------------- ON INIT LOAD DATA --------------------------
  // -------------------------------------------------------------------
  ngOnInit() {
  debugger
    if (this.userId) {
      this.isEditable = true;

      this.userService.getUserById(this.userId).subscribe((usr: any) => {

        if (usr.status === '1') {

          this.userdate = usr.userDetails;

          this.userForm.patchValue({
            first_name: usr.userDetails.first_name || '',
            last_name: usr.userDetails.last_name || '',
            phone_number: usr.userDetails.phone_number || '',
            email: usr.userDetails.email || '',

            company_name: usr.userDetails.company_name || '',
            business_address: usr.userDetails.business_address || '',
            business_type: usr.userDetails.business_type || '',
            tax_number: usr.userDetails.tax_number || '',

            vehicleType: usr.userDetails.vehicleType || usr.userDetails.vehicle_type || '',
            homeCity: usr.userDetails.homeCity || usr.userDetails.city || '',
            emiratesIdBack: usr.userDetails.emiratesIdBack || usr.userDetails.eid_back_pic || ''
          });

          this.imagePath = usr.userDetails.profile_pic;
          this.licensePreview = usr.userDetails.license_pic;

        } else {
          this.toastr.error('Failed to load user details.');
        }
      });

      // Load Rating
      this.userService.getUserRatingById(this.userId).subscribe((usr: any) => {
        this.overallRating = parseFloat(usr.customerData[0].overallRating.$numberDecimal);
      });
    }
  }

  // -------------------------------------------------------------------
  // ------------------------- SUBMIT FORM ------------------------------
  // -------------------------------------------------------------------
  submitted = false;

  onSubmitUser() {
    this.submitted = true;

    if (!this.userForm.valid) {
      this.printErrors();
      return;
    }

    const userData = this.userForm.value;

    // -------------------- CREATE USER --------------------
    if (!this.isEditable) {
      this.userService.createUser(userData).subscribe(
        () => this.toastr.success("User Created Successfully"),
        err => this.toastr.error(err.error.message)
      );
      return;
    }

    // -------------------- UPDATE USER --------------------
    const updateData: any = {
      first_name: userData.first_name,
      last_name: userData.last_name,
      phone_number: userData.phone_number,
      email: userData.email,
      company_name: userData.company_name,
      business_address: userData.business_address,
      business_type: userData.business_type,
      tax_number: userData.tax_number,
      vehicleType: userData.vehicleType,
      homeCity: userData.homeCity,
      emiratesIdBack: userData.emiratesIdBack,
    };

    let useFormData = false;
    const formData = new FormData();

    // Image logic
    if (userData.profile_pic && typeof userData.profile_pic !== "string") {
      formData.append("profile_pic", userData.profile_pic);
      useFormData = true;
    }
    if (userData.license_pic && typeof userData.license_pic !== "string") {
      formData.append("license_pic", userData.license_pic);
      useFormData = true;
    }

    // Add non-file fields into formdata if using formdata
    if (useFormData) {
      Object.keys(updateData).forEach(key => formData.append(key, updateData[key] ?? ""));
    }

    const apiData = useFormData ? formData : updateData;

    this.userService.putUser(this.userId, apiData).subscribe(
      (response: any) => {
        if (response.status === '1') {
          this.toastr.success('User updated successfully.');
          this.userService.closeOverlay();
          this.userService.onCompleted();
        } else {
          this.toastr.error(response.message);
        }
      },
      err => this.toastr.error(err.error?.message || 'Update Failed')
    );
  }

  // ---------------------- IMAGE UPLOAD ----------------------
  uploadProfilePic(event) {
    const file = event.target.files[0];
    if (!file) return;

    const validExt = /(\.jpeg|\.jpg|\.png|\.gif)$/i;
    if (!validExt.exec(file.name)) {
      this.toastr.error("Invalid Image Type!");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      this.toastr.error("Image must be less than 5MB");
      return;
    }

    this.userForm.patchValue({ profile_pic: file });

    // Preview
    const reader = new FileReader();
    reader.onload = (e: any) => (this.imagePath = e.target.result);
    reader.readAsDataURL(file);
  }

uploadFile(event) {
    const file = event.target.files[0];
    if (file) {
      this.userForm.patchValue({ license_pic: file });

      const reader = new FileReader();
      reader.onload = (e: any) => this.licensePreview = e.target.result; // ⭐ Preview license
      reader.readAsDataURL(file);
    }
  }

  // ---------------------- STATUS CHANGE ---------------------
  changeuserStatus(status) {
    this.userService.updateUserApprovStatus(this.userId, status).subscribe(() => {
      this.toastr.success("Status Updated");
      this.userService.closeOverlay();
      this.userService.onCompleted();
    });
  }

  // ---------------------- HELPERS ---------------------------
  printErrors() {
    Object.keys(this.userForm.controls).forEach(key => {
      const errors: ValidationErrors = this.userForm.get(key).errors;
      if (errors) {
        console.log("Error in:", key, errors);
      }
    });
  }

  clearValue() {
    this.userForm.reset();
  }

  closeForm() {
    this.userService.closeOverlay();
  }

  onClickDownload(e, columnName) {
    if (this.userdate[columnName]?.match(/\.(jpeg|jpg|gif|png)$/)) {
      e.preventDefault();
      const link = document.createElement("a");
      link.href = this.userdate[columnName];
      link.click();
    } else {
      this.toastr.error("Image Not Found");
    }
  }
}
